import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class CategoryService {
  static async update(id, data, manage) {

    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation CATEGORY_UPDATE(
          $id: String!
          $data: CategoryInput!
          $manage: ManageInput!
        ) {
          categoryUpdate(id: $id, data: $data,  manage: $manage) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage,
      },
    });

    return response.data.categoryUpdate;
  }

  static async destroyAll(ids, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation CATEGORY_DESTROY($ids: [String!]!,  $manage: ManageInput!) {
          categoryDestroy(ids: $ids,  manage: $manage)
        }
      `,

      variables: {
        ids,
        manage,
      },
    });

    return response.data.categoryDestroy;
  }

  static async create(data, manage) {
    if ( !manage.subpropertyId ) return null;
    
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation CATEGORY_CREATE($data: CategoryInput!,  $manage: ManageInput!) {
          categoryCreate(data: $data,  manage: $manage) {
            id
          }
        }
      `,

      variables: {
        data,
        manage,
      },
    });

    return response.data.categoryCreate;
  }

  static async import(values, importHash, manage) {

    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation CATEGORY_IMPORT(
          $data: CategoryInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          categoryImport(data: $data, importHash: $importHash, manage: $manage)
        }
      `,

      variables: {
        data: values,
        importHash,
        manage,
      },
    });

    return response.data.categoryImport;
  }

  static async find(id, manage) {
    if ( !manage.subpropertyId ) return null;

    const response = await graphqlClient.query({
      query: gql`
        query CATEGORY_FIND($id: String!,  $manage: ManageInput!) {
          categoryFind(id: $id,  manage: $manage) {
            id
            name
            label
            index
            minBirthYear
            maxBirthYear
            minBirthDate {
              day
              month
              year
            }
            maxBirthDate {
              day
              month
              year
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        manage,
      },
    });

    return response.data.categoryFind;
  }

  static async list(filter, orderBy, limit, offset, manage) {
    if ( !manage.subpropertyId ) return { rows: [], count: 0 };

    const response = await graphqlClient.query({
      query: gql`
        query CATEGORY_LIST(
          $filter: CategoryFilterInput
          $orderBy: CategoryOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          categoryList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
              id
              name
              label
              minBirthYear
              maxBirthYear
              minBirthDate {
                day
                month
                year
              }
              maxBirthDate {
                day
                month
                year
              }
              index
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        manage,
      },
    });

    return response.data.categoryList;
  }

  static async listAutocomplete(query, limit, manage) {

    const response = await graphqlClient.query({
      query: gql`
        query CATEGORY_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          categoryAutocomplete(query: $query, limit: $limit,  manage: $manage) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
        manage,
      },
    });

    return response.data.categoryAutocomplete;
  }
}
